"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.value2 = exports.value = exports.buildingType2 = exports.CreateLeadHeatPumpType = exports.CreateLeadBoilerType = exports.CreateLeadHomeBatteryType = exports.CreateLeadAdviceType = exports.CreateLeadThirdPartyType = exports.CreateLeadHouseScanType = exports.CreateLeadSolarPanelType = exports.CreateLeadInsulationType = exports.LeadContextRequestTypeSchema = exports.servicePartner = exports.campaignId = exports.preferredCommunicationChannel = exports.letterCode = exports.heatDistributionSystem = exports.constructionPeriod = exports.buildingType = exports.leadContractType = exports.brand2 = exports.brand = exports.bron = void 0;
/**
 * Generic form submit source
 */
exports.bron = {
    ONLINE: 'Online'
};
/**
 * Brand of the form
 */
exports.brand = {
    ENERGIE_DIRECT: 'ed',
    ESSENT: 'essent'
};
exports.brand2 = {
    ENERGIEDIRECT: 'energiedirect',
    ESSENT: 'essent'
};
exports.leadContractType = {
    HUUR: 'Huur',
    KOOP: 'Koop',
    KOOP_EN_HUUR: 'Koop_en_Huur'
};
exports.buildingType = {
    TUSSENWONING: 'Tussenwoning',
    HOEKWONING: 'Hoekwoning',
    TWEE_ONDER_EEN_KAP_WONING: 'Twee-onder-een-kap woning',
    VRIJSTAANDE_WONING: 'Vrijstaande woning',
    APPARTEMENT: 'Appartement',
    BEDRIJFSPAND: 'Bedrijfspand'
};
exports.constructionPeriod = {
    PRE_1930: 'Pre-1930',
    _1931_1994: '1931-1994',
    POST_1995: 'Post-1995'
};
exports.heatDistributionSystem = {
    RADIATOR: 'Radiator',
    LAGE_TEMPERATUUR_VERWARMING: 'Lage temperatuur verwarming',
    RADIATOREN_EN_LAGE_TEMPERATUUR_VERWARMING: 'Radiatoren en lage temperatuur verwarming',
    LUCHTVERWARMING: 'Luchtverwarming',
    CONVECTOREN: 'Convectoren',
    ONBEKEND: 'Onbekend'
};
/**
 * Letter code
 */
exports.letterCode = {
    F301: 'F301',
    F302: 'F302',
    F304: 'F304',
    F305: 'F305'
};
/**
 * Preferred communication channel
 */
exports.preferredCommunicationChannel = {
    EMAIL: 'EMAIL',
    LETTER: 'LETTER'
};
/**
 * Campaign ID
 */
exports.campaignId = {
    BUDGET_12MNDKORTING: 'Budget_12mndkorting',
    STANDAARD_12MNDKORTING: 'Standaard_12mndkorting',
    CVT_STANDAARD: 'cvt_Standaard',
    PREMIUM_12MNDKORTING: 'Premium_12mndkorting'
};
/**
 * Service partner
 */
exports.servicePartner = {
    ENERGIEWACHT: 'Energiewacht',
    ENERGIEWACHT_WEST: 'Energiewacht West',
    KEMKENS: 'Kemkens',
    VOLTA_LIMBURG: 'Volta Limburg'
};
/**
 * The type of request (context)
 */
exports.LeadContextRequestTypeSchema = {
    DIRECTE_OFFERTE_AANVRAAG: 'Directe Offerte Aanvraag',
    ADVIES: 'Advies',
    OVERGEDRAGEN_VIA_API: 'Overgedragen via API',
    ADVIESGESPREK: 'adviesgesprek'
};
/**
 * The type of lead
 */
exports.CreateLeadInsulationType = {
    INSULATION: 'insulation'
};
/**
 * The type of lead
 */
exports.CreateLeadSolarPanelType = {
    SOLAR_PANEL: 'solarPanel'
};
/**
 * The type of lead
 */
exports.CreateLeadHouseScanType = {
    HOUSE_SCAN: 'houseScan'
};
/**
 * The type of lead
 */
exports.CreateLeadThirdPartyType = {
    THIRD_PARTY: 'thirdParty'
};
/**
 * The type of lead
 */
exports.CreateLeadAdviceType = {
    ADVICE: 'advice'
};
/**
 * The type of lead
 */
exports.CreateLeadHomeBatteryType = {
    HOME_BATTERY: 'homeBattery'
};
/**
 * The type of lead
 */
exports.CreateLeadBoilerType = {
    BOILER: 'boiler'
};
/**
 * The type of lead
 */
exports.CreateLeadHeatPumpType = {
    HEAT_PUMP: 'heatPump'
};
exports.buildingType2 = {
    WOONWAGEN_WOONBOOT: 'woonwagen-woonboot',
    ETAGEWONING: 'etagewoning',
    FLAT_APPARTEMENT: 'flat-appartement',
    VRIJSTAANDE_WONING: 'vrijstaande-woning',
    RIJTJESHUIS: 'rijtjeshuis',
    HOEKWONING: 'hoekwoning',
    TWEE_ONDER_EEN_KAP: 'twee-onder-een-kap',
    GESCHAKELDE_WONING: 'geschakelde-woning'
};
exports.value = {
    NAVIGATE: 'navigate'
};
exports.value2 = {
    VLOERISOLATIE: 'vloerisolatie',
    SPOUWMUURISOLATIE: 'spouwmuurisolatie',
    DAKISOLATIE: 'dakisolatie',
    ANDERS: 'anders'
};
